export const SHOW_STAFF_DETAILS = 'SHOW_STAFF_DETAILS';
